import {
  OriginType,
  FeedbackTypeEnum,
  IMConfigTypeEnum,
} from "@/app/types/typeConfig/chatQuestion";
import request from "@/request";
const prefix = "/gw/robot";

export interface FeedbackPropsType {
  email?: string;
  feedback: string;
  feedbackType?: number;
  knowledgeId?: string;
  orderNo?: string;
  origin: OriginType;
  userId: string;
  sessionId?: string;
  feedbackClass?: FeedbackTypeEnum;
  requestId?: string;
  extendField4?: string;
}
export const questionFeedback = async (params: FeedbackPropsType) => {
  try {
    await request.post(`${prefix}/front/feedback`, {
      ...params,
    });
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};

// 获取点赞点踩的配置文案
export interface IMConfigPropsType {
  languageCode: string;
  type: IMConfigTypeEnum;
}
export const queryFeedbackConfig = async (params: IMConfigPropsType) => {
  try {
    const res: { content: string; content2: string; online: boolean } =
      await request.get(
        `${prefix}/duty/roster/show?languageCode=${params.languageCode}&type=${params.type}`,
      );
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

// 查询订单是否存在
export interface QueryOrderExistPropsTYpe {
  email: string;
  orderNum: string;
}
export const queryOrderExist = async (params: QueryOrderExistPropsTYpe) => {
  try {
    const flag: boolean = await request.post(`${prefix}/front/order/query`, {
      ...params,
    });
    return Promise.resolve(flag);
  } catch (err) {
    return Promise.reject(err);
  }
};

export interface UploadHandlerResponseType {
  url: string;
  id: string;
  dataType: string;
  fileSize: number;
  fileOriginalName: string;
}
export const uploadHandler = async (file: File, url?: string) => {
  const formData = new FormData();
  formData.append("file", file, file.name);
  url = url || "/file/fileRecord/uploadFile?storageType=1";
  try {
    const data: UploadHandlerResponseType = await request.upload(
      url,
      formData,
      {
        crossDomain: true,
        withCredentials: true,
        // 注意：不要设置 Content-Type，让浏览器自动设置 multipart/form-data
      },
    );

    return Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};

// 保存机器人信息
export interface SaveRobotInfoPropsType {
  clientId: string;
  clientTimestamp: number;
  content: string;
  senderType: string;
  type?: string;
}
export const saveRobotInfo = async (params: SaveRobotInfoPropsType[]) => {
  try {
    await request.post(`/cus/message/robot-message`, params);
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};

export const closeOpenAIChat = async (
  requestId: string,
  xRobotUser: string,
) => {
  fetch(`${prefix}/sse/close?requestId=${requestId}`, {
    method: "GET",
    keepalive: true,
    headers: {
      "x-robot-user": xRobotUser,
    },
  });
};
